module.exports = __webpack_public_path__ + "static/media/template_indicadores_gerais_v1.5e3dbb45.csv";